/* DecantGems sample page: the size pills (snippets/dg-size-picker.liquid) are radio inputs of the product form.
   This script mirrors the chosen size in the price line (hidden for a size without a price: a price of 0 is
   never shown), in the hidden size field of the notify form and in the address (?variant=), so a shared or
   reloaded link opens the same size. Without it the form still adds the chosen size to the cart.
   Loaded as a module (sections/dg-product-hero.liquid): Shopify's asset minifier turns a dynamic import() into require(). */
import { CartLinesUpdateEvent } from '@shopify/events';
import { flyToCart, notifyCart, pickImage } from '@dg/fly';

(function () {
  'use strict';
  function init(buy) {
    var radios = Array.prototype.slice.call(buy.querySelectorAll('[data-dg-size]'));
    if (!radios.length) return;
    var line = buy.querySelector('[data-dg-price-line]');
    var price = buy.querySelector('[data-dg-price]');
    var per = buy.querySelector('[data-dg-per-ml]');
    var name = buy.querySelector('[data-dg-size-name]');
    var field = buy.querySelector('[data-dg-size-field]');
    function show(radio) {
      var has = !!radio.dataset.price;
      if (line) line.hidden = !has;
      if (price) price.textContent = has ? radio.dataset.price : '';
      if (name) name.textContent = radio.dataset.size || '';
      if (per) per.textContent = has && radio.dataset.perMl ? ' · ' + radio.dataset.perMl : '';
      if (field) field.value = radio.dataset.size || '';
      var sticky = document.querySelector('[data-dg-sticky-price]');
      if (sticky) {
        var amount = sticky.querySelector('[data-dg-sticky-amount]');
        var size = sticky.querySelector('[data-dg-sticky-size]');
        if (amount) amount.textContent = has ? radio.dataset.price : '';
        if (size) size.textContent = (radio.dataset.size || '') + ' · ';
        sticky.hidden = !has;
      }
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', radio.value);
        window.history.replaceState(window.history.state, '', url.toString());
      } catch (e) {}
    }
    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (radio.checked) show(radio);
      });
    });
  }
  /* Add to cart without leaving the page (flows-01): the form posts to /cart/add.js, Horizon's cart drawer and
     header count update through the standard cart:lines-update event, then the drawer opens. If anything is
     missing (no drawer on this page, the events module does not load), the form falls back to its plain POST. */
  /* Cart as a page (owner, 16 Oct; Theme settings > Cart type "page"): there is no drawer. The sample goes in with
     /cart/add.js and the visitor STAYS on this page (owner, 16 Oct: the FragranceGems add-to-cart animation, not a jump to
     /cart): the photo flies to the header cart icon (assets/dg-fly.js), the count updates on landing. A refusal (sold out,
     stock limit) stays here as an inline message. Without JavaScript the plain POST to /cart/add still lands on /cart. */
  function cartError(form, text) {
    var err = form.querySelector('[data-dg-cart-error]');
    if (!err) {
      err = document.createElement('p');
      err.className = 'dg-form__error';
      err.setAttribute('role', 'alert');
      err.setAttribute('data-dg-cart-error', '');
      form.appendChild(err);
    }
    err.textContent = text || '';
    err.hidden = false;
  }
  function pageCart(form) {
    var busy = false;
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (busy) return;
      busy = true;
      var buttons = Array.prototype.slice.call(document.querySelectorAll('#DgProductForm button[type="submit"], button[form="DgProductForm"]'));
      buttons.forEach(function (b) { b.setAttribute('aria-busy', 'true'); b.disabled = true; });
      function done() { busy = false; buttons.forEach(function (b) { b.removeAttribute('aria-busy'); b.disabled = false; }); }
      var err = form.querySelector('[data-dg-cart-error]');
      if (err) err.hidden = true;
      var cartUrl = (window.Theme && Theme.routes && Theme.routes.cart_url) || '/cart';
      var data = new FormData(form);
      var clicked = event.submitter || buttons[0] || form;
      // fly on the click, like FragranceGems: the feedback should not wait for the network
      var landed = flyToCart(pickImage('.dg-pdp__img', clicked));
      fetch('/cart/add.js', { method: 'POST', body: data, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res && res.status) { done(); cartError(form, res.description || res.message || ''); return; }
          var qty = Number(data.get('quantity')) || 1;
          return notifyCart('dg-sample', [{ merchandiseId: String(data.get('id')), quantity: qty }], landed)
            .then(function () { done(); })
            .catch(function () { window.location.assign(cartUrl); });
        })
        .catch(function (e) { if (window.console) console.warn('[dg-sample] add to cart: plain form post', e); busy = false; form.submit(); });
    });
  }
  function ajaxCart(form) {
    var drawer = document.getElementById('cart-drawer');
    if (!window.fetch || !window.FormData) return;
    if (!drawer) { pageCart(form); return; }
    var busy = false;
    function fallback() { busy = false; form.submit(); }
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (busy) return;
      busy = true;
      var buttons = Array.prototype.slice.call(document.querySelectorAll('#DgProductForm button[type="submit"], button[form="DgProductForm"]'));
      buttons.forEach(function (b) { b.setAttribute('aria-busy', 'true'); b.disabled = true; });
      function done() { busy = false; buttons.forEach(function (b) { b.removeAttribute('aria-busy'); b.disabled = false; }); }
      var err = form.querySelector('[data-dg-cart-error]');
      if (err) err.hidden = true;
      Promise.resolve().then(function () {
        var Ev = CartLinesUpdateEvent;
        var data = new FormData(form);
        var ids = [];
        document.querySelectorAll('cart-items-component').forEach(function (c) { if (c.dataset.sectionId) ids.push(c.dataset.sectionId); });
        if (ids.length) data.append('sections', ids.join(','));
        var qty = Number(data.get('quantity')) || 1;
        var deferred = Ev.createPromise();
        form.dispatchEvent(new Ev({ action: 'add', context: 'product', lines: [{ merchandiseId: String(data.get('id')), quantity: qty }], promise: deferred.promise }));
        var added = null;
        return fetch('/cart/add.js', { method: 'POST', body: data, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (r) { return r.json(); })
          .then(function (res) { added = res; return fetch('/cart.js', { headers: { Accept: 'application/json' } }); })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var failed = !!(added && added.status);
            deferred.resolve({ cart: Ev.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: 'dg-sample', sourceId: 'DgProductForm', itemCount: qty, sections: failed ? undefined : added.sections, didError: failed } });
            done();
            if (failed) {
              if (!err) {
                err = document.createElement('p');
                err.className = 'dg-form__error';
                err.setAttribute('role', 'alert');
                err.setAttribute('data-dg-cart-error', '');
                form.appendChild(err);
              }
              err.textContent = added.description || added.message || '';
              err.hidden = false;
              return;
            }
            if (!drawer.hasAttribute('open') && typeof drawer.open === 'function') drawer.open();
          })
          .catch(function (e) {
            deferred.reject(e);
            // the line is in the cart but the page could not be updated: show the cart page instead of adding twice
            if (added && !added.status) { done(); window.location.href = '/cart'; return; }
            throw e;
          });
      }).catch(function (e) { if (window.console) console.warn('[dg-sample] add to cart: plain form post', e); done(); fallback(); });
    });
  }
  function boot() {
    document.querySelectorAll('[data-dg-buy]').forEach(init);
    var form = document.getElementById('DgProductForm');
    if (form) ajaxCart(form);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
